import { render, staticRenderFns } from "./Catalogue.vue?vue&type=template&id=2e6b4698&scoped=true&"
import script from "./Catalogue.vue?vue&type=script&lang=js&"
export * from "./Catalogue.vue?vue&type=script&lang=js&"
import style0 from "./Catalogue.vue?vue&type=style&index=0&id=2e6b4698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b4698",
  null
  
)

export default component.exports